import { useEffect } from 'react'

import AgoraRTC from 'agora-rtc-react'

import { useModal } from '../../../../hooks/use-modal'
import { useScreenSharePinning } from '../../hooks/useScreenSharePinning'
import { ScreenSharingModeMainContent } from '../ScreenSharingModeMainContent/ScreenSharingModeMainContent'
import { VideoCallRoomRemotePlayers } from '../VideoCallRoomRemotePlayers/VideoCallRoomRemotePlayers'

type Props = {
  colorScheme?: 'blue' | 'green'
}

export const VideoCallRoomInCall: React.FC<Props> = ({
  colorScheme = 'blue',
}) => {
  const { remoteUsers, isScreenSharingActive, mainUser, setPinnedMainUserId } =
    useScreenSharePinning()
  const { showModal } = useModal()

  useEffect(() => {
    // iOS系の場合、Agoraの音声の自動再生時にユーザビリティ設定のために失敗することがある。
    // 何かしらユーザーの画面操作を挟めば音声が再生されるため、モーダルを表示・ボタンクリックを促すようにする。
    // See: https://docportal.shengwang.cn/cn/voice-legacy/autoplay_policy_web_ng?platform=iOS
    AgoraRTC.onAutoplayFailed = () => {
      showModal({
        title: '通話が開始されています',
        content: 'マイクをONにしてください',
        submitText: '確認',
        submitButtonColor: 'blue',
        size: 'sm',
        hideCancel: true,
        onSubmit: () => {},
      })
    }
  }, [showModal])

  return isScreenSharingActive ? (
    <ScreenSharingModeMainContent
      mainUser={mainUser}
      onSelectMainUser={setPinnedMainUserId}
      colorScheme={colorScheme}
    />
  ) : (
    <VideoCallRoomRemotePlayers remoteUsers={remoteUsers} />
  )
}
